<template>
  <div
    id="nav"
    class="navbar navbar-expand-lg navbar-light sticky-top bg-white "
    :class="withShadow ? '' : 'shadow-lg'"
  >
    <div class="container-fluid px-0">
      <nav id="content" class="d-flex bg-white w-75 m-auto">
        <router-link id="home" class="navbar-brand" to="/"
          ><img id="logo" class="w-10" src="/img/logo.png" alt="Logo Phare" />
          <small class="font-family-base font-weight-light px-2 ml-1"
            >{{ "components.navbar.title" | i18n }}
          </small>
        </router-link>
        <div class="ml-auto">
          <button
            @click="logout()"
            class="btn bg-transparent hoverable d-flex pb-6"
            id="btn-logout"
          >
            <i class="sign in alternate icon" />
          </button>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";
/**
 * @description Affiche la barre de navigation
 * @author Francine Jin
 * @author Gabriel Bertrand
 * @vue-computed {Boolean} withShadow - Retourne si la barre de navigation doit avoir un ombrage pour la page actuelle
 */
export default {
  name: "NavBar",
  component: {
    Vue,
    VueRouter
  },
  methods: {
    /**
     * @description Fonction qui déconnecte l'utilisateur et le redirige vers le login
     */
    async logout() {
      try {
        await this.$api.logout();
        location.reload();
      } catch {
        location.reload();
      }
    }
  },
  computed: {
    withShadow() {
      const withRoutes = ["details", "clientDetails", "servers"];
      return withRoutes.includes(this.$route.name);
    }
  }
};
</script>

<style lang="scss" scoped>
.hoverable:hover {
  color: $primary;
}

.pb-6 {
  padding-bottom: 0.75rem;
}

#nav {
  height: 56px;
}

#home {
  &:hover {
    opacity: 75% !important;
  }
}

#btn-logout {
  &:focus,
  &:active {
    box-shadow: none !important;
  }
}

small {
  color: $gray-600;
  letter-spacing: 3px;
}

@media screen and (min-width: 1028px) {
  #content {
    margin-left: 12.5rem;
    margin-right: 12.5rem;
  }
}
@media screen and (max-width: 1025px) {
  #content {
    width: 90% !important;
  }
}
@media screen and (max-width: 414px) {
  #content {
    width: 100% !important;
  }
}

@media screen and (min-width: 1366px) {
  #content {
    width: 1366px;
  }
}
</style>
